<template>
  <i>
    <svg width="31"
         height="22"
         viewBox="0 0 31 22"
         fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path d="M29.728 0.0214844C30.4107 0.0214844 30.688 0.341484 30.56 0.981483L27.104 20.6295C27.0187 21.1842 26.72 21.4615 26.208 21.4615H16.032C15.264 21.4615 15.008 21.0775 15.264 20.3095L21.344 0.789486C21.472 0.277485 21.8133 0.0214844 22.368 0.0214844H29.728ZM14.56 0.0214844C15.2427 0.0214844 15.52 0.341484 15.392 0.981483L11.936 20.6295C11.8507 21.1842 11.552 21.4615 11.04 21.4615H0.864C0.096 21.4615 -0.16 21.0775 0.096 20.3095L6.176 0.789486C6.304 0.277485 6.64533 0.0214844 7.2 0.0214844H14.56Z"
            fill="currentColor" />
    </svg>
  </i>
</template>
